import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';
import {
  COMMUNITY_IDENTIFICATION_CODE_TYPES_RESOURCE,
  CREATE_COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE,
} from '../../constants';

const CreateIdentificationCodeTypeService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE,
      method: 'post',
      request: (id, body, callback, t) => ({
        url: apiRoutes.communityIdentificationCodeTypes(id),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: COMMUNITY_IDENTIFICATION_CODE_TYPES_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createIdentificationCodeTypeFailed'),
            onSuccessMessage: t('createIdentificationCodeTypeSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateIdentificationCodeTypeService;
